import { createContext } from 'react';

export const AuthContext = createContext();

export const LOCAL_STORAGE_SESSION_KEY = 'has-active-session';
